<template>
  <section class="policy-form flex-1">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRules"
        :disabled="showBuyable"
        :model="formData">
        <div
          v-if="isCancel"
          class="box">
          <h3></h3>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Cancellation Effective Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box">
          <h2>Policy Detail</h2>
          <template  v-if="!isCancel">
            <div
              class="flex-sb">
              <div class="form-item form-half">
                <span>{{ isEndorsement? 'Endorsement Effective Date': 'Expected Effective Date' }}</span>
                <el-form-item
                  ref="pcy_expry_dt"
                  :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                  <v-date-picker
                    v-model="formData.pcy_cmnt_dt"
                  />
                </el-form-item>
              </div>
            </div>
          </template>
          <div
            class="form-item form-half">
            <span>Third Party’s bodily injury</span>
            <el-form-item
              ref="tpbi"
              prop="tpbi">
              <v-input
                v-model="formData.tpbi"
                disabled
                prepend="HK$"
              />
            </el-form-item>
          </div>
          <div
            class="form-item form-half">
            <span>Number of Operator(s)</span>
            <el-form-item
              ref="tpbi"
              prop="tpbi">
              <v-select
                v-model="formData.no_of_opera"
                :list="numberFourOptions"
                @change="handlerDirvier"
              />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <h3>Policyholder Details</h3>
          <div class="form-item form-half">
            <span>Title</span>
            <el-form-item
              ref="isrd_title"
              prop="isrd_title">
              <v-select
                v-model="formData.isrd_title"
                :disabled="isCancel||checkDisabled('isrd_title')"
                :list="titleOptions"
                @change="handlerSamePolicyInfo" />
            </el-form-item>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Last Name</span>
              <el-form-item prop="isrd_lst_nm">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  uppercase
                  :disabled="isCancel||checkDisabled('isrd_lst_nm')"
                  @change="handlerSamePolicyInfo"/>
              </el-form-item>
            </div>

          </div>
          <div class="form-item form-half">
            <span>First Name</span>
            <el-form-item prop="isrd_fst_nm">
              <v-input
                v-model="formData.isrd_fst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_fst_nm')"
                @change="handlerSamePolicyInfo"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Date of Birth</span>
            <el-form-item prop="isrd_dob">
              <v-birth-day
                v-model="formData.isrd_dob"
                :disabled="isCancel||checkDisabled('isrd_dob')"
                @change="handlerSamePolicyInfo"
              />
            </el-form-item>
          </div>
          <div class="form-half">
            <div class="form-item">
              <span>{{formData.id_type==2?'Passport':'HKID'}} Number</span>
              <el-form-item
                ref="id_type"
              >
                <v-radio-group
                  v-model="formData.id_type"
                  :disabled="isCancel||checkDisabled('id_type')"
                  :list="personalIdTypOptions"
                  @change="handlerSamePolicyInfo"
                />
              </el-form-item>
              <el-form-item
                v-if="formData.id_type==1"
                prop="id_no"
              >
                <v-input
                  v-model="formData.id_no"
                  uppercase
                  :disabled="isCancel||checkDisabled('id_no')"
                  placeholder="A123456(3), please input A1234563"
                  class="mg-t-5"
                  @change="handlerSamePolicyInfo" />
              </el-form-item>
              <template v-if="formData.id_type==2">
                <div class="form-item mg-t-5">
                  <el-form-item
                    prop="id_no">
                    <v-input
                      v-model="formData.id_no"
                      uppercase
                      :disabled="checkDisabled('id_no')"
                      class="mg-t-5"
                      @change="handlerSamePolicyInfo" />
                  </el-form-item>
                </div>
              </template>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Mobile Number</span>
            <el-form-item prop="mobile_no">
              <v-input
                v-model="formData.mobile_no"
                :disabled="isCancel||checkDisabled('mobile_no')"
                type="number"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Email</span>
            <el-form-item
              ref="email"
              prop="email"
              :rules="rules.email">
              <v-input
                v-model="formData.email"
                :disabled="isCancel||checkDisabled('email')"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Occupation</span>
            <el-form-item
              ref="occ_id"
              prop="occ_id">
              <v-select
                v-model="formData.occ_id"
                :list="localAllOptions.occupation" />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Policyholder is one of the Designated Operator?</span>
            <el-form-item prop="hldr_is_opera">
              <v-radio-group
                v-model="formData.hldr_is_opera"
                :border="true"
                :disabled="isCancel"
                :list="yesNoOptions"
                @change="handlerSamePolicyInfo" />
            </el-form-item>
          </div>
          <span class="title">Correspondence Address</span>
          <address-form
            ref="address-form"
            :formType="1"
            :formDataLock="formDataLock"
            :form="formData"
            :disabled="isCancel||showBuyable"
            :not-valid="checkRefer===1?true:false"
            @getFormData="getAddressForm" />

        </div>
        <div class="box">
          <span class="title">Information of UAS</span>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Make</span>
              <el-form-item
                ref="brand"
                prop="brand">
                <v-input
                  v-model="formData.brand"
                  uppercase
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Model</span>
              <el-form-item
                ref="model"
                prop="model">
                <v-input
                  v-model="formData.model"
                  uppercase
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>UAS serial no.</span>
              <el-form-item
                ref="uas_no"
                prop="uas_no">
                <v-input
                  v-model="formData.uas_no"
                  uppercase
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Year of manufacture</span>
              <el-form-item
                ref="year_of_manu"
                prop="year_of_manu">
                <v-input
                  v-model="formData.year_of_manu"
                  maxlength="4"
                  key-number
                  key-non-chinese
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Manufacturer and model of sensor</span>
              <el-form-item
                ref="manu_model_of_sen"
                prop="manu_model_of_sen">
                <v-input
                  v-model="formData.manu_model_of_sen"
                  uppercase
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>
                <span>Total weights</span>
                <span class="tip">
                  (including parts, accessories, batteries and fuel)
                </span>
              </span>
              <el-form-item
                ref="weight_id"
                prop="weight_id">
                <v-select
                  v-model="formData.weight_id"
                  :list="allOptions30.weights"
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>
                <span>Maximum speed limit (km/h)</span>
              </span>
              <el-form-item
                ref="max_speed"
                prop="max_speed">
                <v-input
                  v-model="formData.max_speed"
                  key-non-chinese
                  key-number
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>
                Autopilot system
              </span>
              <el-form-item
                ref="autopilot_sys"
                prop="autopilot_sys">
                <v-radio-group
                  v-model="formData.autopilot_sys"
                  :list="yesNoOptions"
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="formData.autopilot_sys"
            class="flex-sb">
            <div class="form-item form-half">
              <span>
                Please provide details
              </span>
              <el-form-item
                ref="autopilot_detail"
                prop="autopilot_detail">
                <v-input
                  v-model="formData.autopilot_detail"
                  type="textarea"
                  :rows="4"/>
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>
                Expected yearly flying hours
              </span>
              <el-form-item
                ref="yearly_hours"
                prop="yearly_hours">
                <v-input
                  v-model="formData.yearly_hours"
                  key-number
                  key-non-chinese
                />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="box">
          <h2>Information of Designated Operator(s)</h2>
          <div
            v-for="(item,index) in formData.info_opera_list"
            :key="index"
            class="travel-card ">
            <label class="flex-align-center">
              <span class="travel-title mg-l-8">Operator {{index+1}}</span>
            </label>
            <template>
              <div class="flex-sb mg-t-20">
                <div class=" form-half">
                  <div class="form-item">
                    <span>Relationship</span>
                    <el-form-item
                      :ref="'info_opera_list.'+index+'.opera_rel'"
                      :prop="'info_opera_list.'+index+'.opera_rel'"
                      :rules="!isRules?[]:rules.rel"
                    >
                      <v-select
                        v-model="item.opera_rel"
                        :disabled="policyOneDriver&&index==0||isCancel"
                        :list="relationList(index)"/>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <Span>Title</Span>
                    <el-form-item
                      :ref="'info_opera_list.'+index+'.opera_title'"
                      :prop="'info_opera_list.'+index+'.opera_title'"
                      :rules="!isRules?[]:rules.title"
                    >
                      <v-select
                        v-model="item.opera_title"
                        :disabled="isCancel||policyOneDriver&&index==0"
                        :list="titleOptions" />
                    </el-form-item>
                  </div>
                  <div >
                    <div class="form-item ">
                      <span>Last Name</span>
                      <el-form-item
                        :ref="'info_opera_list.'+index+'.opera_lst_nm'"
                        :prop="'info_opera_list.'+index+'.opera_lst_nm'"
                        :rules="!isRules?[]:rules.lst_nm">
                        <v-input
                          v-model="item.opera_lst_nm"
                          uppercase
                          :disabled="isCancel||policyOneDriver&&index==0 ||checkDisabled('opera_lst_nm')"/>
                      </el-form-item>
                    </div>
                    <div class="form-item ">
                      <span>First Name</span>
                      <el-form-item
                        :ref="'info_opera_list.'+index+'.opera_fst_nm'"
                        :prop="'info_opera_list.'+index+'.opera_fst_nm'"
                        :rules="!isRules?[]:rules.fst_nm">
                        <v-input
                          v-model="item.opera_fst_nm"
                          uppercase
                          :disabled="isCancel||policyOneDriver&&index==0 || checkDisabled('opera_fst_nm')"/>
                      </el-form-item>
                    </div>
                  </div>

                </div>
                <div class="form-half">
                  <div class="form-item">
                    <span>Date of Birth</span>
                    <el-form-item
                      :ref="'info_opera_list.'+index+'.opera_dob'"
                      :prop="'info_opera_list.'+index+'.opera_dob'"
                      :rules="!isRules?[]:rules.dob"
                    >
                      <v-birth-day
                        v-model="item.opera_dob"
                        :disabled="isCancel||policyOneDriver&&index==0"/>
                    </el-form-item>
                  </div>

                  <div class="form-item">
                    <span>{{item.opera_id_type==2?'Passport':'HKID'}} Number</span>
                    <el-form-item
                      ref="opera_id_type"
                    >
                      <v-radio-group
                        v-model="item.opera_id_type"
                        :disabled="isCancel||policyOneDriver&&index==0"
                        :list="personalIdTypOptions" />
                    </el-form-item>
                    <el-form-item
                      v-if="item.id_type==1"
                      :ref="'info_opera_list.'+index+'.opera_id_no'"
                      :prop="'info_opera_list.'+index+'.opera_id_no'"
                      :rules="!isRules?[]:rules.id_no"
                    >
                      <v-input
                        v-model="item.opera_id_no"
                        uppercase
                        placeholder="A123456(3), please input A1234563"
                        :disabled="isCancel||policyOneDriver&&index==0"
                        class="mg-t-5" />
                    </el-form-item>
                    <template v-else>
                      <div class="form-item">
                        <el-form-item
                          :prop="'info_opera_list.'+index+'.opera_id_no'"
                          :rules="!isRules?[]:rules.id_no"
                        >
                          <v-input
                            v-model="item.opera_id_no"
                            uppercase
                            :disabled="isCancel||policyOneDriver&&index==0"
                            class="mg-t-5" />
                        </el-form-item>
                      </div>
                    </template>
                  </div>

                  <div class="form-item">
                    <span>Occupation</span>
                    <el-form-item
                      :ref="'info_opera_list.' + index + '.opera_occ_id'"
                      :rules="!isRules?[]:rules.select"
                      :prop="'info_opera_list.' + index + '.opera_occ_id'" >
                      <v-select
                        v-model="item.opera_occ_id"
                        :disabled="isCancel||policyOneDriver&&index==0"
                        :list="allOptions30.occupation"/>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>


        <div class="box travel-box">
          <h2>Upload Document</h2>
          <div >
            <div class="form-item form-half">
              <span>Policyholder HKID</span>
              <el-form-item prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :disabled="isCancel||showBuyable||checkDisabled(['id_no','id_type'])"
                  :fileData="formData.id_type_pic"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path'
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
            <div class="drivers-file-container">
              <div
                v-for="(item, index) in formData.info_opera_list"
                v-show="index!=0&&policyOneDriver"
                :key="index"
              >
                <template>
                  <span class="title">Operator {{ index + 1 }}</span>
                  <div class="flex">
                    <div class="form-item mg-r-15">
                      <span>HKID Card File</span>
                      <el-form-item prop="id_type_pic_path_id">
                        <v-upload
                          :card="true"
                          :disabled="index==0&&policyOneDriver"
                          :fileData="{
                            url: item.opera_id_type_pic_url,
                            thumb_url: item.opera_id_type_pic_url,
                            client_name: item.opera_id_type_pic_client_name,

                          }"
                          :otherData="{
                            index,
                            type: 'opera',
                            idKey: 'opera_id_type_pic_path_id',
                            nameKey: 'opera_id_type_pic_path',
                            urlKey: 'opera_id_type_pic_url',
                            client_name:'opera_id_type_pic_client_name',

                          }"
                          @delete="handlerDeleteFile"
                          @uploadSuccess="handlerUploadSuccess"
                        />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'

export default {
  name: 'TravelPolicyForm',
  components: {
    AddressForm
    // TravelPolicyHolderForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    form: {
      type: Object,
      default: ()=>({})
    },
    occData: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isCheckDate: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    isAdjust: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const opera_obj ={
      opera_rel:'',
      opera_title:'',
      opera_id_type:1,
      opera_id_no:'',
      opera_dob:'',
      opera_lst_nm:'',
      opera_fst_nm:'',

      opera_id_type_pic_path: '',
      opera_id_type_pic_path_id: '',
      opera_id_type_pic_url: '',
      opera_licence_pic_path: '',
      opera_licence_pic_path_id: '',
      opera_licence_pic_url: '',
      opera_id_type_pic_client_name: '',
      opera_licence_client_name: '',
    }
    return {
      formDataLock: 0,
      policyOneTravel:true,
      init:false,
      obj: {
        opera_rel:'',
        opera_title:'',
        opera_id_type:1,
        opera_id_no:'',
        opera_dob:'',
        opera_lst_nm:'',
        opera_fst_nm:'',
        opera_occ_id:'',
        opera_id_type_pic_path: '',
        opera_id_type_pic_path_id: '',
        opera_id_type_pic_url: '',
        opera_licence_pic_path: '',
        opera_licence_pic_path_id: '',
        opera_licence_pic_url: '',
        opera_id_type_pic_client_name: '',
        opera_licence_client_name: '',
      },
      formData: {
        class_id: 30,
        tpbi: '',
        no_of_opera: 1,

        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        // file
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type_pic: {},

        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_dob: '',
        id_type: 1,
        id_no: '',
        mobile_no: '',
        isrd_dob_date: '',
        email: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        hldr_is_traveler_ind:'',
        occ_id:'',

        brand:'',
        model:'',
        uas_no:'',
        manu_model_of_sen:'',
        weight_id:'',
        max_speed:'',
        autopilot_sys:'',
        autopilot_detail:'',
        info_opera_list:[],
        yearly_hours:'',
        year_of_manu:'',

      },
      subForm: {
        'address-form': false,
      },
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      otherData: {},
      extraRules: {
        id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        pp_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_nationality_seq: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        rel: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions30
    },
    relList(){
      let arr = this.localAllOptions.relation
      arr = arr.filter(item=>{
        return item.id!=1
      })
      return arr
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })
      Object.keys(this.ruleRequestData).some(key => {
        rulesOption[key][0].required = true
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
    },
    isRules(){
      return this.checkRefer ===2
    },
    policyOneDriver(){
      let {hldr_is_opera} = this.formData||{}
      return hldr_is_opera==1
    },
    relationList() {
      return index=>{
        let data = this.localAllOptions.relation || []
        const other =  data.filter(item => item.is_insured != 1)
        if(index==0 && this.policyOneDriver){
          return data
        }else{
          return  other
        }
      }
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      handler(val) {
        if(val) {
          // 觸發更新就賦值，避免二次更新
          // this.oldFormDataLock = this.formDataLock
          const formValue = JSON.parse(JSON.stringify(val))
          // this.formData = Object.assign(
          //   this.formData,
          //   formValue
          // )
          this.formData = {...this.formData,...formValue}
          let {no_of_opera=0,info_opera_list=[],pcy_cmnt_dt} = val||{}
          this.formData.pcy_cmnt_dt = pcy_cmnt_dt||''
          if(!no_of_opera){
            this.formData.no_of_opera =1
            this.formData.info_opera_list=[JSON.parse(JSON.stringify(this.obj))]

          }
          this.handler().handlerAddress(formValue)

        }
      }
    },
    occData: {
      immediate: true,
      handler(val) {
        let {cust_typ} = this.form
        let keys = {
          isrd_title: '',
          isrd_lst_nm: '',
          isrd_dob: '',
          isrd_fst_nm: '',
          id_type: '',
          id_no: '',
          mobile_no: '',
          isrd_dob_date: '',
        }
        if (val) {
          Object.keys(keys).some(key => {
            if (key in val) {
              if(val[key])
                this.formData[key] = val[key]
            }
          })
        }
      }
    },
  },
  methods: {
    handlerDirvier(){
      let {class_id} = this.formData
      let {info_opera_list,no_of_opera} = this.formData
      // let obj = JSON.parse(JSON.stringify(this.drivers))
      if(info_opera_list.length<no_of_opera){
        for(var i= info_opera_list.length;i<no_of_opera;i++){
          let obj = JSON.parse(JSON.stringify(this.obj))
          info_opera_list.push(obj)
        }
      }else {
        info_opera_list.splice(no_of_opera,info_opera_list.length)
      }
    },
    // file-container 組件刪除文件
    handlerDeleteFile(otherData) {
      const {type, index, idKey, nameKey, urlKey} = otherData
      if (type === 'opera' ) {
        [urlKey, nameKey, idKey].some(key => {
          this.$set(
            this.formData.info_opera_list[index],
            key,
            ''
          )
        })
        if (index == 0 && this.policyOneDriver && type === 'opera') {
          this.$set(this.formData, 'id_type_pic', null)
          this.$set(this.formData, 'id_type_pic_path_id', '')
          this.$set(this.formData, 'id_type_pic_path', '')
        }
      }
    },
    handlerUploadSuccess({data, result, otherData}) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      const {id = '', name = '', url = '', client_name = ''} = data
      if (index === '') {
        if (target) {
          this.$set(this.formData, target, data)
          if (target == 'id_type_pic') {
            if (this.policyOneDriver) {
              this.$set(this.formData.info_opera_list[0], 'opera_id_type_pic_path_id', id)
              this.$set(this.formData.info_opera_list[0], 'opera_id_type_pic_path', name)
              this.$set(this.formData.info_opera_list[0], 'opera_id_type_pic_url', url)
              this.$set(this.formData.info_opera_list[0], 'opera_id_type_pic_client_name', client_name)
            }
          }
        }
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, name)
        this.$refs['form'].clearValidate([idKey])
      }
      // drivers
      else {
        this.$set(this.formData.info_opera_list[index], nameKey, name)
        this.$set(this.formData.info_opera_list[index], idKey, id)
        this.$set(this.formData.info_opera_list[index], 'client_name', client_name)
        this.$set(this.formData.info_opera_list[index], otherData.client_name, client_name)
        this.$set(
          this.formData.info_opera_list[index],
          urlKey,
          url)
        if (index == 0 && this.policyOneDriver && type === 'opera') {
          this.$set(this.formData, 'id_type_pic', data)
          this.$set(this.formData, 'id_type_pic_path_id', id)
          this.$set(this.formData, 'id_type_pic_path', name)
        }
      }
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    handlerSamePolicyInfo(){
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title,
        id_type_pic,hldr_is_traveler_ind,occ_id
      } = this.formData||{}
      const { id, client_name, path, url } = this.formData.id_type_pic || {}
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      if(this.policyOneDriver) {
        Object.assign(this.formData.info_opera_list[0], {
          opera_rel: 1,
          opera_dob: isrd_dob,
          opera_fst_nm: isrd_fst_nm,
          opera_id_no: id_no,
          opera_occ_id: occ_id,
          opera_id_type: id_type,
          opera_lst_nm: isrd_lst_nm,
          opera_title: isrd_title,
          opera_id_type_pic_path_id: id,
          opera_id_type_pic_path: path,
          opera_id_type_pic_url: url,
          opera_client_name: client_name,
        })
      }
      console.log('this.formData.info_opera_list[0]--',this.formData.info_opera_list[0])
    },
    getConfirmChangeResult(result) {
      const params = this.formResult
      if(result) {
        params.upd_def_addr = 1 // 更新用戶資料
      }
      this.$emit('getFormData', params, this.otherData)
    },
    handlerTravelStatus(status){
      this.policyOneTravel = status
    },
    async submitForm(otherData = {}) {
      await this.$refs['form'].validate((valid, rules)=> {
        if(valid) {
          this.otherData = otherData
          // debugger
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if(Object.values(this.subForm).some(item => item === false)) {
            return
          }
          const result = {
            ...this.formData,
          }
          this.$emit('getFormData', result, otherData)
        }   else {
          this.scrollToValidDom(rules)
        }
      })
    },
    getSubFormData(formName, data) {
      this.subForm[formName] = true
      Object.assign(this.formData, data)
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      const result = {
        ...this.formData,
      }
      this.$emit('getFormData', result, otherData)

    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      if(form == 'address-form') {
        this.formData = Object.assign(this.formData, data)
      }
      else {
        this.handler().handlerAddressResult(data)
      }
    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const obj = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          const params = {}
          Object.keys(this.addressForm).some(key => {
            params[key] = data[key]
          })
          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            cor_addr_room: addr_room,
            cor_addr_floor: addr_floor,
            cor_addr_block: addr_block,
            cor_addr_building: addr_building,
            cor_addr_street: addr_street,
            cor_addr_district: addr_district,
            cor_addr_area: addr_area,
            cor_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-form {
  .title {
    font-size: 20px;
    color: #616266;
    font-weight: 500;
  }
  .travel-card{
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    padding: 20px;
    margin:0 0 20px 0;
    .travel-title{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
    }
  }

  .travel-group{
    ::v-deep .v-radio-group{
      .el-radio-group{
        display: flex;
        flex-direction: column;
        .el-radio{
          margin-top: 10px;
        }
      }
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .el-date-editor--daterange{
    width: 100%;
  }
}
</style>
